import axios from "axios";
import numeral from "numeral";
import { store } from "../../App";

export const fetchDollarPrices = async () => {
  try {
    const res = await axios.get(`/dollar-prices?lastOne=true`);

    store.dispatch({ type: "FETCH_DOLLAR_PRICES", data: res.data });
  } catch (e) {
    throw e;
  }
};


export const convertCurrency = (amount, currency, forShow, withFormat, haveRounding) => {
  const currentDollarPrice = store.getState().dollarPrices.currentPrice.price;
  const fourNumDollar = (currentDollarPrice + 1500 + '').substring(0, 4);

  if (currency === "USD") {
    if (forShow) {
      return numeral(haveRounding ? Math.round(amount) : amount).format("0.00$")
    };
    if (withFormat) return numeral(amount / fourNumDollar).format("0.00$");
    return (amount / fourNumDollar).toFixed(2);
    // return numeral(amount).format("0.0$");
  }
  if (currency === "IQD") {
    if (forShow) return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'IQD', roundingIncrement: haveRounding ? 1000 : 1 }).format((amount))
    if (withFormat) return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'IQD', roundingIncrement: haveRounding ? 1000 : 1 }).format((Math.round((amount * fourNumDollar) / 1000) * 1000))
    return Math.round((amount * fourNumDollar) / 1000) * 1000;//! 1000 is the rounding increment
  }
}